/* globals DEBUG */

import {combineReducers, applyMiddleware, compose, createStore} from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import gaMiddleware from './gaMiddleware'
import {mediaQueryTracker} from "state/actions/mediaQueryTracker"

import * as reducers from 'state/reducers'

export default function storeFactory(initialState) {
	const reducer = combineReducers(reducers)
	const devtoolsExt = global.devToolsExtension && global.devToolsExtension()

	const middleWares = [thunk]
	if (DEBUG) {
		if (!devtoolsExt) {
			// We don't have the Redux extension in the browser, show the Redux log
			const logger = createLogger()
			middleWares.push(logger)
		}
	} else {
		// Only enable Google Analytics in production build
		middleWares.push(gaMiddleware)
	}

	const storeWrapper = compose(
		applyMiddleware(...middleWares),
		devtoolsExt || (f => f)
	)
	const store = createStore(reducer, initialState, storeWrapper)

	store.dispatch(mediaQueryTracker({
		isPhone: "screen and (max-width: 768px)",
		isTablet: "screen and (max-width: 1024px) and (orientation: portrait)",
		innerWidth: true,
	}))

	return store
}



// WEBPACK FOOTER //
// ./state/makeStore.js